import {
  GetPlatformCatalogsParams,
  PlatformCatalogSortByParam,
  PlatformCatalogSortParameter,
  PlatformCatalogStatusParameter,
  PublicationStatus,
} from "@bvhi/backend-api/apis";
import { createFileRoute } from "@tanstack/react-router";
import { WithErrorBoundary } from "../../../hoc/with-error-boundary";
import { withPermissionCheck } from "../../../hoc/with-permission-check";
import { CatalogsListView } from "../../../views/app/catalog/catalogs/list/catalogs-list-view";

export const Route = createFileRoute("/_main/app/catalogs/")({
  validateSearch: (search: Record<string, unknown>): GetPlatformCatalogsParams => {
    return {
      page: Number(search?.page ?? 0),
      size: Number(search?.size ?? 25),
      sort: (search?.sort as PlatformCatalogSortParameter) || [PlatformCatalogSortByParam.NAME_ASC],
      platformCatalogStatus: (search?.platformCatalogStatus as PlatformCatalogStatusParameter) || [
        PublicationStatus.PUBLISHED,
        PublicationStatus.DRAFT,
      ],
    };
  },
  component: () =>
    WithErrorBoundary({
      Component: withPermissionCheck({ Component: CatalogsListView }),
    }),
});
